import { UseFormReturn, FieldValues, Path } from 'react-hook-form'
import showErrorToast from '@/common/utils/showErrorToast'

type FormMode = 'create' | 'edit'

interface BasePlayerFormValues {
	username?: string
}

export const handlePlayerFormError = <
	T extends FieldValues & BasePlayerFormValues,
>(
	error: any,
	form: UseFormReturn<T>,
	mode: FormMode,
) => {
	const errorMessage = error?.response?.data?.message

	if (Array.isArray(errorMessage)) {
		errorMessage.forEach((message) => {
			if (message.includes('phone must be a valid phone number')) {
				form.setError('phone' as Path<T>, {
					message: 'กรุณากรอกเบอร์โทรศัพท์ที่ถูกต้อง',
				})
			}
		})
		return
	}

	if (errorMessage === 'DUPLICATE_PHONE') {
		form.setError('phone' as Path<T>, {
			message: 'เบอร์โทรศัพท์นี้ถูกใช้แล้ว',
		})
		return
	}

	showErrorToast(
		errorMessage ||
			(mode === 'create'
				? 'ไม่สามารถเพิ่มผู้ใช้งานได้'
				: 'แก้ไขข้อมูลไม่สำเร็จ'),
	)
}
